const ReviewBulkOrder = ({
  getCustomerLabel,
  validOrderItems,
  getEquivalent,
  reviewData,
}) => {
  console.log("Image test:", validOrderItems);
  return (
    <div>
      <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-sm text-gray-600">Customer</span>
          <span className="text-red-500">*</span>
        </div>
        <div className="text-base font-medium">{getCustomerLabel()}</div>
      </div>

      <h3 className="text-base font-medium mb-4">Products to Purchase</h3>

      {validOrderItems.length === 0 ? (
        <div className="p-8 text-center text-gray-500 bg-gray-50 rounded-lg">
          No products added to the order.
        </div>
      ) : (
        <>
          <div className="bg-gray-50 rounded-lg overflow-hidden">
            <div className="grid grid-cols-12 gap-4 p-3 bg-gray-100 text-xs font-medium text-gray-700">
              <div className="col-span-4">PRODUCT</div>
              <div className="col-span-3 text-center">QUANTITY</div>
              <div className="col-span-2 text-center">PRICE</div>
              <div className="col-span-3 text-center">SUBTOTAL</div>
            </div>

            {validOrderItems.map((item) => (
              <div
                key={item.id}
                className="grid grid-cols-12 gap-4 p-3 border-b items-center"
              >
                <div className="col-span-4 flex items-center gap-2">
                  <div className="w-10 h-10 rounded bg-orange-100 flex items-center justify-center overflow-hidden flex-shrink-0">
                    {item.productImage ? (
                      <img
                        src={item.productImage}
                        alt={item.productName || "Product"}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.style.display = "none";
                          const parent = e.target.parentElement;
                          if (
                            parent &&
                            !parent.querySelector(".fallback-emoji")
                          ) {
                            const fallback = document.createElement("span");
                            fallback.className = "text-xl fallback-emoji";
                            fallback.textContent = "🍽️";
                            parent.appendChild(fallback);
                          }
                        }}
                      />
                    ) : (
                      <span className="text-xl">🍽️</span>
                    )}
                  </div>
                  <span className="text-sm">{item.productName}</span>
                </div>
                <div className="col-span-3 text-center text-sm">
                  x{item.quantity} ({getEquivalent(item)})
                </div>
                <div className="col-span-2 text-center text-sm">
                  ₦{item.price.toLocaleString()}
                </div>
                <div className="col-span-3 text-center text-sm font-medium">
                  ₦{item.subtotal.toLocaleString()}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 bg-orange-50 p-4 rounded-lg">
            <div className="flex justify-between mb-2">
              <span className="text-sm">Subtotal:</span>
              <span className="text-sm font-medium">
                ₦{reviewData.subtotal.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between mb-3">
              <span className="text-sm">Discount:</span>
              <span className="text-sm font-medium">{reviewData.discount}</span>
            </div>
            <div className="flex justify-between pt-3 border-t border-orange-200">
              <span className="font-medium">Total Amount:</span>
              <span className="text-lg font-bold">
                ₦{reviewData.total.toLocaleString()}
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default ReviewBulkOrder;
